export const tableColumnlineList = [
  {
    field: 'settlementDesc', // 1
    title: '结算说明',
    width: '120',
  },
  {
    field: 'expenseTypeName', // 1
    title: '费用类型',
    width: '120',
  },
  {
    field: 'originalPrice',
    title: '原币结算单价(含税)',
    width: '150',
  },
  {
    field: 'settlementQuantity',
    title: '结算数量',
    width: '140',
  },
  {
    field: 'unitName',
    title: '计量单位',
    width: '140',
  },
  {
    field: 'originalAmount',
    title: '原币结算金额(含税)',
    width: '160',
  },
  {
    field: 'originalAmountWithoutTax',
    title: '原币结算金额 (不含税)',
    width: '160',
  },
  {
    field: 'originalTaxAmount',
    title: '原币税额',
    width: '140',
  },
  {
    field: 'currencyName',
    title: '币种',
    width: '140',
  },
  {
    field: 'exchangeRate',
    title: '汇率',
    width: '140',
  },
  {
    field: 'domesticAmount',
    title: '本币结算金额（含税）',
    width: '170',
  },
  {
    field: 'domesticAmountWithoutTax',
    title: '本币结算金额 (不含税)',
    width: '160',
  },
  {
    field: 'domesticTaxAmount',
    title: '本币税额',
    width: '140',
  },
  // {
  //     field: 'additional',
  //     title: '附加',
  //     width: '140',
  // },

  {
    field: 'businessDocNo',
    title: '业务单据编号',
    width: '140',
  },
  {
    field: 'remark',
    title: '备注',
    width: '140',
  },
];
export const lineDetailList = [
  {
    field: 'expenseNo',
    title: '费用编号',
    width: '120',
  },
  {
    field: 'expenseTypeName',
    title: '费用类型',
    width: '120',
  },
  {
    field: 'originalPrice',
    title: '原币结算单价（含税）',
    width: '180',
  },
  {
    field: 'settlementQuantity',
    title: '结算数量',
    width: '140',
  },
  {
    field: 'unitName',
    title: '计量单位',
    width: '140',
  },
  {
    field: 'originalAmount',
    title: '原币结算金额(含税)',
    width: '170',
  },
  {
    field: 'originalAmountWithoutTax',
    title: '原币结算金额 (不含税)',
    width: '170',
  },
  {
    field: 'originalTaxAmount',
    title: '原币税额',
    width: '140',
  },
  {
    field: 'currencyName',
    title: '币种',
    width: '140',
  },
  {
    field: 'exchangeRate',
    title: '汇率',
    width: '140',
  },
  {
    field: 'domesticAmount',
    title: '本币结算金额（含税）',
    width: '170',
  },
  {
    field: 'domesticAmountWithoutTax',
    title: '本币结算金额 (不含税)',
    width: '170',
  },
  {
    field: 'domesticTaxAmount',
    title: '本币税额',
    width: '140',
  },

  {
    field: 'taxRate',
    title: '税率',
    width: '140',
  },
  {
    field: 'periodDateFrom',
    title: '业务账期日期从',
    width: '160',
  },
  {
    field: 'periodDateUntil',
    title: '业务账期日期至',
    width: '160',
  },
  {
    field: 'businessDocNo',
    title: '业务单据编号',
    width: '140',
  },
  {
    field: 'productName',
    title: '商品名称',
    width: '140',
  },
  {
    field: 'goodsCategoryName',
    title: '商品类别',
    width: '140',
  },
  {
    field: 'productModel',
    title: '规格',
    width: '140',
  },
  {
    field: 'remark',
    title: '备注',
    width: '140',
  },
];
export const settlementColumn = [
  // {
  //   field: 'projectInitiationNo',
  //   title: '项目编号',
  //   visible: true,
  // },
  {
    field: 'contractNo',
    title: '合同编号',
    visible: true,
  },
  {
    field: 'customerName',
    title: '客户名称',
    visible: true,
  },
  {
    field: 'settlementDate',
    title: '结算日期',
    visible: true,
  },
  {
    field: 'receivableAccountPeriod',
    title: '应收帐期',
    visible: true,
  },
  {
    field: 'settlementType',
    title: '结算类型',
    visible: true,
  },
  {
    field: 'originalTotalAmount',
    title: '原币结算总金额（含税）',
    visible: true,
  },
  {
    field: 'domesticTotalAmount',
    title: '本币结算总金额（含税）',
    visible: true,
  },
  {
    field: 'currencyName',
    title: '币种',
    visible: true,
  },
  {
    field: 'exchangeRate',
    title: '汇率',
    visible: true,
  },
  {
    field: 'operate',
    title: '操作',
    visible: true,
  },
];
